<template>
    <div class="product-family">
        <div class="section-small section-large-md-up">
            <ProductFamilyFinishes v-if="hasFinishFilter" :finishes="finishesArray" :portfolios="portfoliosArray" :styles="stylesArray" :activeFinish="selectedFinish" v-on:filterChange="filterChange"></ProductFamilyFinishes>
        </div>
        <template v-if="initialized && resultsArray.length">
            <ProductFamilyResults :results="resultsArray" :translations="translations"> </ProductFamilyResults>
        </template>
        <template v-if="initialized && !resultsArray.length"><div class="text-center">No Results Available</div></template>
    </div>
    <LoadIndicator :loadingResults="isLoading"></LoadIndicator>
</template>
<script lang="ts">
import ProductFamilyFinishes from 'Vue/components/productFamily/ProductFamilyFinishes.vue';
import ProductFamilyResults from 'Vue/components/productFamily/ProductFamilyResults.vue';
// import {
// 	filterCategory,
// 	productFilteringRequest,
// 	productFilteringResponse
// } from "Vue/interfaces/ProductFilteringInterfaces";
import { FamilyRequest } from 'Api/apis';
import LoadIndicator from 'Vue/components/shared/LoadIndicator.vue';
import { IProductFamilyTranslations } from 'Vue/interfaces/Interfaces';

export default {
    name: 'ProductFamily',
    components: {
        LoadIndicator,
        ProductFamilyFinishes,
        ProductFamilyResults,
    },
    data() {
        return {
            familyData: {},
            selectedFinish: {},
            categorySlug: '',
            productCategory: '',
            initialized: false,
            isLoading: true,
            params: null,
            translations: {} as IProductFamilyTranslations,
        };
    },
    methods: {
        async setupFilters() {
            let component = document.querySelector('.js-component-info');
            this.categorySlug = component.getAttribute('data-category-slug');
            this.productCategory = component.getAttribute('data-product-category');

            let request = {
                category: this.categorySlug,
                filterOptions: {
                    pageNumber: 1,
                    sort: 'New',
                },
                filters: null,
            };

            await this.getProductFamily(request);
            this.initialized = true;
        },

        async getProductFamily(request: any) {
            this.familyData = await FamilyRequest(request);
        },

        filterChange(finish, portfolio, style, event?) {
            event && event.preventDefault();
            if (finish) {
                this.selectedFinish = finish;
            }

            if (!portfolio) {
                portfolio = '';
            }

            if (!style) {
                style = '';
            }

            this.productFamilyRequest(this.selectedFinish, portfolio, style);

            let pageUrl = `?finish=${encodeURIComponent(this.selectedFinish?.title)}&portfolio=${portfolio}&style=${style}`;
            window.history.replaceState('', '', pageUrl);
        },

        async productFamilyRequest(finish: any, portfolio: string, style: string, paging: any = 1, sort: any = 'DisplayNameAsc') {
            this.isLoading = true;
            let requestWithUpdatedValues = {
                category: this.categorySlug,
                filterOptions: {
                    pageNumber: paging,
                    sort: sort,
                },
                filters: [
                    {
                        name: 'finish',
                        values: [finish.title],
                    },
                    {
                        name: 'portfolio',
                        values: [portfolio],
                    },
                    {
                        name: 'style',
                        values: [style],
                    }
                ],
            };

            //only update the results not the whole familyData object so the finishes dont rerender
            await this.getProductFamily(requestWithUpdatedValues);
            setTimeout(() => {
                this.isLoading = false;
            }, 300);
        },
        getTranslations() {
            let productFamilyParentDiv = document.getElementById('productFamilyData');
            return JSON.parse(productFamilyParentDiv.getAttribute('data-translations'));
        },
    },

    computed: {
        hasFinishFilter() {
            return this.familyData?.filters?.length;
        },

        activeFinish() {
            return this.selectedFinish;
        },

        finishesArray() {
            return this.familyData?.filters?.filter((e) => e.slug === 'finish').length && this.familyData?.filters?.filter((e) => e.slug === 'finish')[0].filterValues?.length ? this.familyData?.filters?.filter((e) => e.slug === 'finish')[0]?.filterValues : [];
        },

        portfoliosArray() {
            return this.familyData?.filters?.filter((e) => e.slug === 'portfolio').length && this.familyData?.filters?.filter((e) => e.slug === 'portfolio')[0].filterValues?.length ? this.familyData?.filters?.filter((e) => e.slug === 'portfolio')[0]?.filterValues : [];
        },

        stylesArray() {
            return this.familyData?.filters?.filter((e) => e.slug === 'style').length && this.familyData?.filters?.filter((e) => e.slug === 'style')[0].filterValues?.length ? this.familyData?.filters?.filter((e) => e.slug === 'style')[0]?.filterValues : [];
        },

        resultsArray() {
            return this.familyData?.results?.length ? this.familyData?.results : [];
        },
    },

    created() {
        this.setupFilters();
        this.translations = this.getTranslations();
    },
};
</script>
